import { getFormattedDate } from "@core/utils/date";
import copy from "copy-to-clipboard";
import React, { ReactNode } from "react";

export function getNthEnding(n: number): string {
    if (n >= 4 && n <= 20) {
        return 'th';
    }

    const lastDigit = n % 10;
    switch (lastDigit) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

export function copyToClipboard(text: string) {
    copy(text, { format: 'text/plain' });
}

export function copyTableData(data: string[][]) {
    const strData =  [
        `Extracted ${getFormattedDate(new Date().toISOString(), "M/DD/YYYY")}`,
        ...data.map(row => row.join("\t")),
    ].join("\r\n");

    copyToClipboard(strData);
}

export function getStringContentFromReactNode(node: ReactNode): string {
	if (typeof node === 'string' || typeof node === 'number') {
		// If it's a string or number, just return it
		return node.toString();
	}

	if (Array.isArray(node)) {
		// If it's an array (children can be an array of nodes), recursively handle each item
		return node.map(getStringContentFromReactNode).join('');
	}

	if (React.isValidElement(node)) {
		// If it's a valid React element, check for children and process recursively
		if (node.props && node.props.children) {
			return getStringContentFromReactNode(node.props.children);
		}
	}

	return '';
}

export function capitalizeFirstLetter(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}